<div class="flex flex--col u-p---- card-filter-container">
  <dl role="presentation" class="accordion-group scrollable" style="margin-top: 0px; margin-bottom: 10px">
    <ng-container *ngFor="let columnState of columnStateList">
      <div class="accordion">
        <dt role="heading" aria-level="3">
          <button
            [attr.aria-expanded]="columnState.isFilterActive"
            [attr.aria-controls]="'panel-' + columnState.column.id"
            [id]="'header-' + columnState.column.id"
            class="accordion__heading flex flex--middle"
            (click)="onAccordionClick(columnState)"
          >
            <ng-container *ngIf="columnState.isFilterActive; then iconExpanded; else iconCollapsed"> </ng-container>
            <div type="button" class="accordion__trigger text-bold-16">
              {{ columnState.column.headerLabel | translate }}
              <div class="text-12 inline-filter-description">
                {{ columnState.filterDescription | translate }}
              </div>
            </div>
          </button>
        </dt>
        <dd
          class="accordion__panel accordion__panel--caret-on-right"
          role="region"
          [attr.aria-labelledby]="'content-' + columnState.column.id"
          [attr.aria-hidden]="!columnState.isFilterActive"
          [class.accordion__panel--opened]="columnState.isFilterActive"
          [class.accordion__panel--caret-on-right]="columnState.isFilterActive"
          [class.accordion__panel--hidden]="!columnState.isFilterActive"
          [id]="'panel-' + columnState.column.id"
        >
          <virtual-grid-header-dropdown
            [column]="columnState.column"
            [filterConfig]="columnState.column.filterConfig"
            [filterComponent]="columnState.column.filterComponent"
            [filterData]="columnState.filterData"
            [cardFilterChild]="true"
            [isActive]="columnState.isFilterActive"
            [sortCriteria]="[]"
            (closeRequest)="onCloseRequest(columnState, $event)"
            (filterDataChange)="onFilterDataChange(columnState, $event)"
          >
          </virtual-grid-header-dropdown>
        </dd>
      </div>
    </ng-container>
  </dl>
  <div style="margin-bottom: 10px">
    <virtual-grid-filter-tag-panel
      [excludedColumnIds]="include"
      [filterCriteria]="filterCriteria"
      headerLabel="{{ 'vg.otherFilters' | translate }}"
      [showAllTags]="true"
      (filterCriteriaChange)="filterCriteriaChange.emit($event)"
    >
    </virtual-grid-filter-tag-panel>
  </div>
  <div id="buttons-container" class="flex flex--row flex--stretch flex--justify u-p---">
    <button class="button button--tertiary button-clear" (click)="onClear()">
      <span class="u-ph---">
        {{ 'vg.clear' | translate }}
      </span>
    </button>
    <button class="button button--primary button-apply" (click)="onApply()">
      <span class="u-ph---">
        {{ 'vg.done' | translate }}
      </span>
    </button>
  </div>
</div>

<ng-template #iconCollapsed>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    class="accordion__chevron accordion__chevron--right"
    style="fill: currentcolor; width: 16px; height: 16px"
  >
    <g>
      <path
        d="M8,11.5a.47.47,0,0,1-.35-.15l-6.5-6.5a.48.48,0,0,1,0-.7.48.48,0,0,1,.7,0L8,10.29l6.15-6.14a.49.49,0,0,1,.7.7l-6.5,6.5A.47.47,0,0,1,8,11.5Z"
      ></path>
    </g>
  </svg>
</ng-template>

<ng-template #iconExpanded>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    class="accordion__chevron accordion__chevron--right"
    style="fill: currentcolor; width: 16px; height: 16px"
  >
    <g>
      <path
        d="M14.5,11.5a.47.47,0,0,1-.35-.15L8,5.21,1.85,11.35a.48.48,0,0,1-.7,0,.48.48,0,0,1,0-.7l6.5-6.5a.48.48,0,0,1,.7,0l6.5,6.5a.48.48,0,0,1,0,.7A.47.47,0,0,1,14.5,11.5Z"
      ></path>
    </g>
  </svg>
</ng-template>
